import React from 'react';
import Text from '../../../../Components/Base/Text/Text';
// @ts-ignore
import styles from './NZCIListCluster.module.scss';

interface Props {
	title: string;
}

const NZCIListCluster: React.FC<Props> = ({ title }) => {
	return (
		<div className={styles.wrapper}>
			<div className={styles.title}>
				<Text tx={title} inline />
			</div>
		</div>
	);
};

export default NZCIListCluster;
